export default "__VITE_ASSET__f0d3906a__"